/**
 * AdminOrcaDefaultsRpcClient - AtomRpc integration for admin orca defaults endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaDefaultsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaDefaultsRpcClient extends AtomRpc.Tag<AdminOrcaDefaultsRpcClient>()(
  "AdminOrcaDefaultsRpcClient",
  {
    group: AdminOrcaDefaultsRpcs,
    protocol: makeRpcClientLayer(AdminOrcaDefaultsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
